// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__yRCTG","tabsBox":"styles_tabsBox__O9zxj","createButton":"styles_createButton__2F-WK"};